import { useState } from 'react'
import { MessageSquarePlus } from 'lucide-react'

import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { cn } from '@/lib/utils'

import { NotesPanel } from './NotesPanel'

interface NotesCellProps {
  invoiceId: string
  latestNote: string | null | undefined
  noteCount: number
  onMutate?: () => void
}

const TRUNCATE_LIMIT = 60

function truncate(text: string, max: number): string {
  if (text.length <= max) return text
  return text.slice(0, max).trimEnd() + '…'
}

export function NotesCell({ invoiceId, latestNote, noteCount, onMutate }: NotesCellProps) {
  const [open, setOpen] = useState(false)
  const hasNotes = noteCount > 0
  const firstLine = latestNote ? latestNote.split('\n')[0] : ''

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          onClick={(e) => e.stopPropagation()}
          className={cn(
            'group inline-flex items-center gap-2 w-full max-w-[260px] text-left px-2 py-1 rounded-md',
            'hover:bg-neutral-100 transition-colors',
            !hasNotes && 'text-neutral-400'
          )}
          title={hasNotes ? latestNote || '' : 'Add note'}
        >
          {hasNotes ? (
            <>
              <span className="truncate text-sm text-neutral-800">
                {truncate(firstLine, TRUNCATE_LIMIT)}
              </span>
              {noteCount > 1 && (
                <span className="shrink-0 text-[10px] font-semibold text-neutral-600 bg-neutral-200 rounded px-1.5 py-0.5">
                  +{noteCount - 1}
                </span>
              )}
            </>
          ) : (
            <>
              <MessageSquarePlus className="w-4 h-4 opacity-60 group-hover:opacity-100" />
              <span className="text-xs">Add note</span>
            </>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="w-[420px] p-0"
        onClick={(e) => e.stopPropagation()}
      >
        <NotesPanel invoiceId={invoiceId} onMutate={onMutate} />
      </PopoverContent>
    </Popover>
  )
}
